import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { IProduct } from '../products';
import {
  IFetchNewDealerRequest,
  INewDealerRejection,
  INewDealerRequestApiResponse,
  INewDealerRequestCart,
  INewDealerRequestCompleteEvent,
  INewDealerRequestEvent,
  INewDealerRequestFull,
  INewDealerRequestMin,
  NewDealerRequestCompleteEventRequest,
  NewDealerRequestEventRequest,
  NewDealerRequestUpdateRequest
} from './newDealerInterfaces';

export async function addNewDealerRequestCompleteEvent(
  request: NewDealerRequestCompleteEventRequest
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestCompleteEvent>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestCompleteEvent>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerRequestCompleteEvent(), request);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function addNewDealerRequestEvent(
  request: NewDealerRequestEventRequest
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestEvent>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestEvent>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerRequestEvent(), request);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function advanceNewDealerState(
  newDealerRequestId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestApiResponse>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestApiResponse>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerAdvanceState(newDealerRequestId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function completeNewDealerRequest(
  newDealerRequestId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerComplete(newDealerRequestId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function createNewDealerCustomer(
  newDealerRequestId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestApiResponse>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestApiResponse>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerRequestCreateCustomer(newDealerRequestId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function deleteNewDealerCart(cartId: number): Promise<IApiExecuteRespone<IEntityWithMessages<number>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<number>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.delete(ApiUrls.newDealerRequestCart(cartId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function deleteNewDealerRequestEvent(
  newDealerRequestEventId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<number>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<number>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.delete(ApiUrls.newDealerRequestEvent(newDealerRequestEventId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function deleteNewDealerRequestCompleteEvent(
  request: NewDealerRequestCompleteEventRequest
): Promise<IApiExecuteRespone<IEntityWithMessages<NewDealerRequestCompleteEventRequest>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<NewDealerRequestCompleteEventRequest>> = {
    requestFailed: false
  };

  try {
    const apiResponse = await httpService.delete(ApiUrls.newDealerRequestCompleteEvent(), request);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function fetchNewDealerRequest(
  request: IFetchNewDealerRequest
): Promise<IApiExecuteRespone<INewDealerRequestApiResponse>> {
  const response: IApiExecuteRespone<INewDealerRequestApiResponse> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.newDealer(request));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function fetchNewDealerRequests(): Promise<IApiExecuteRespone<INewDealerRequestMin[]>> {
  const response: IApiExecuteRespone<INewDealerRequestMin[]> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.newDealerRequestMinList());
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function importNewDealerOrders(
  newDealerRequestId: number
): Promise<IApiExecuteRespone<IEntityWithMessages<string[]>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<string[]>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerRequestImportOrders(newDealerRequestId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function updateNewDealerProgram(
  programLevel: INewDealerRequestCart
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestCart>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestCart>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerProgramLevel(), programLevel);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function updateNewDealerRequest(
  request: NewDealerRequestUpdateRequest
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerRequest(request.newDealerRequestId), request);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function rejectNewDealerRequest(
  request: Pick<INewDealerRejection, 'newDealerRequestId' | 'reason'>
): Promise<IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.newDealerRequestReject(request.newDealerRequestId), request);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function searchNewDealerCatalog(value: {
  cartId: number;
  searchTerm: string;
}): Promise<IApiExecuteRespone<IProduct[]>> {
  const response: IApiExecuteRespone<IProduct[]> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.newDealerCatalogSearch(value.cartId, value.searchTerm));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function validateNewDealerRequest(newDealerRequestId: number): Promise<IApiExecuteRespone<string[]>> {
  const response: IApiExecuteRespone<string[]> = { requestFailed: false };

  try {
    const apiResponse = await httpService.get(ApiUrls.newDealerRequestValidate(newDealerRequestId));
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}
